import { formatPence } from './money';

// What staff are told about the money side of archiving a gymnast: each paid
// future booking that was cancelled is credited to the family. "" when there
// was nothing to credit.
export function archiveCreditNote(cascade) {
  const n = cascade?.creditsIssued || 0;
  if (!n) return '';
  return ` ${n} paid session${n === 1 ? '' : 's'} cancelled and credited to the family (${formatPence(cascade.creditTotal)}).`;
}
